import { render } from "./TagRounded.vue?vue&type=template&id=43f6d010"
import script from "./TagRounded.vue?vue&type=script&lang=js"
export * from "./TagRounded.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__